export const ex = {
  path: "/pemeriksaan",
  name: "pemeriksaan",
  hidden: false,
  component: () => import("@/components/pemeriksaan/index"),
  meta: {
    title: "Form pemeriksaan",
    icon: "fa-user-md",
    roles: [""]
  }
};
export default ex;



// WEBPACK FOOTER //
// ./src/router/modules/examination.js